import IDataAccessObjectProperties from '../../../../../../core/DAL/DAO/IDataAccessObjectProperties';

/**
 *  @see OrganizationUiResource.groovy
 */
export default class BundleVersionDAOProperties extends IDataAccessObjectProperties {

	constructor() {

		let path = 'release_bundle';
		let paramDefaults = {};
		let customActions = {
			getReleaseBundleVersion: {
				url: `${path}/:release_bundle/:release_bundle_version`,
				method: 'GET',
                cancellable: true,
				params: {
					$no_spinner: true
				}
			},
			getDistributionTracking: {
				url: `${path}/:release_bundle/:release_bundle_version/distribution_tracking`,
				method: 'GET',
				isArray: true,
				params: {
					$no_spinner: true
				}
			},
			distribute: {
				url: `distribution/:release_bundle/:release_bundle_version`,
				method: 'POST',
				notifications:true,
			},
			deleteReleaseBundleVersionGlobally: {
				url: `distribution/:release_bundle/:release_bundle_version/delete`,
				method: 'POST',
				notifications:true,
			},
			deleteReleaseBundleVersionLocally: {
				url: `${path}/:release_bundle/:release_bundle_version`,
				method: 'DELETE',
				notifications:true,
			},
			stopReleaseBundleVersionDistributions: {
				url: `distribution/:release_bundle/:release_bundle_version/abort`,
				method: 'PUT',
				notifications:true,
				isArray: true
			},
			toggleArchiveReleaseBundleVersionLocally: {
				url: `${path}/:release_bundle/:release_bundle_version`,
				method: 'DELETE',
				notifications:true,
			},
			sign: {
				url: `${path}/:release_bundle/:release_bundle_version/sign`,
				method: 'POST',
				notifications:true,
			},
			isPassphraseRequired: {
				url: 'pgp/info',
				method: 'GET'
			}
		};

		super(path, paramDefaults, null, customActions);
	}
};

BundleVersionDAOProperties.META = {
	name: 'BundleVersionDAOProperties'
};



// WEBPACK FOOTER //
// ./modules/distribution/modules/distribution/components/bundle/version/DAO/BundleVersionDAOProperties.js